// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WO5ho","left":"styles_left__DGrbI"};